if (!customElements.get('pdp-subscription-terms')) {
  customElements.define('pdp-subscription-terms', class extends HTMLElement {
    connectedCallback() {
      const buttons = this.closest('.product-form__buttons');
      const content = this.querySelector('[data-subscription-terms-content]');
      if (!buttons || !content) return;

      const moveConsent = () => {
        const consent = buttons.querySelector('.shopify-payment-button #shopify-buyer-consent');
        if (consent) content.replaceChildren(consent);
      };

      this.observer = new MutationObserver(moveConsent);
      this.observer.observe(buttons, { childList: true, subtree: true });
      moveConsent();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}
